/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div className={`relative mb-3 flex mx-[10px] rounded-[10px] hover:cursor-pointer font-figtree ${activeRoute(route.path) ? 'bg-[#2369d2]' : ''}`}>
              <li
                className={`my-[10px] flex cursor-pointer items-center px-6 text-[16px]`}
                key={index}
              >
                <span
                  className={`${
                    activeRoute(route.path) === true
                      ? "font-[500] text-[#fff] dark:text-white font-figtree"
                      : "font-medium text-[#525252] font-figtree"
                  }`}
                  style={{ fontFamily: "figtree" }}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 ml-3 flex ${
                    activeRoute(route.path) === true
                      ? "font-[500] text-[#fff] dark:text-white font-figtree"
                      : "font-[500] text-[#525252] font-figtree"
                  }`}
                  style={{ fontFamily: "figtree" }}
                >
                  {route.name}
                </p>
              </li>
              {/* {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-[43px] w-1  bg-[#2369d2]" />
              ) : null} */}
            </div>
          </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
